<template>
  <div>
    <div class="p-4 grid grid-rows-1">
      <div class="grid-cols-1">
        <vx-card>
          <h4 style="font-family: Lora; font-size: x-large">
            COVID-19 Victorian Information Dashboard:
          </h4>
          <!--          <Breadcrumbs-->
          <!--            :breadcrumbs="[{ title: 'Dashboards', to: '/dashboards' }]"-->
          <!--          />-->
          <p class="mt-2 text-sm">
            This dashboard is designed to provide you with up to date and
            reliable information and resources to assist your efforts to address
            the COVID-19 pandemic.
          </p>
          <p class="mt-2 text-sm">
            This software tool was built by team of volunteer software
            developers with the hope of doing our part to assist in your crucial
            work.
          </p>
          <p class="mt-2 text-sm">
            To all of our healthcare workers, thank you. If you or your
            colleagues are facing problems that our team can build tools to help
            you manage, please contact
            <a href="mailto: edmund@need2know.io">edmund@need2know.io</a>
          </p>
        </vx-card>
      </div>
    </div>
    <div
      class="grid sm:grid-rows-3 md:grid-rows-1 lg:grid-rows-1 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3"
    >
      <router-link class="column-margin" to="/dashboards/global">
        <vs-card actionable style="background: #000;">
          <h4 style="color: #fff;">Global Data:</h4>
          <p style="color: #00aaff; font-family: 'Source Sans Pro';">
            Open for more details
          </p>
          <GlobalStatisticsCard />
        </vs-card>
      </router-link>
      <router-link class="column-margin" to="/dashboards/australia">
        <vs-card actionable>
          <h4>Australian Data:</h4>
          <p style="color: #00843D; font-family: 'Source Sans Pro';">
            Open for more details
          </p>
          <AustralianStatisticsCard />
        </vs-card>
      </router-link>
      <router-link class="column-margin" to="/dashboards/victoria">
        <vs-card actionable>
          <h4>Victorian Data:</h4>
          <p style="color: rgb(0, 1, 124); font-family: 'Source Sans Pro';">
            Open for more details
          </p>
          <VictorianStatisticsCard />
        </vs-card>
      </router-link>
    </div>
    <div
      class="grid sm:grid-rows-4 md:grid-rows-2 lg:grid-rows-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4"
    >
      <div class="p-3">
        <div class="column-margin">
          <vs-card class="lancet">
            <div @click="navigate('lancet')" class="pageLink">
              <h4>The Lancet</h4>
              <a
                href="https://www.thelancet.com/coronavirus"
                target="_blank"
                class="mb-2"
                >Select a card to read more</a
              >
            </div>
            <RssCard
              v-for="(article, index) in limitedLancetArticles"
              :key="index"
              :article="article"
            ></RssCard>
          </vs-card>
        </div>
      </div>
      <div class="p-3">
        <div class="column-margin">
          <vs-card class="nejm">
            <div @click="navigate('nejm')" class="pageLink">
              <h4>
                <span>The</span> New England Journal <span>of</span> Medicine
              </h4>
              <a
                class="mb-2"
                href="https://www.nejm.org/coronavirus"
                target="_blank"
                >Select a card to read more</a
              >
            </div>
            <RssCard
              v-for="(article, index) in limitedNejmArticles"
              :key="index"
              :article="article"
            ></RssCard>
          </vs-card>
        </div>
      </div>
      <div class="p-3">
        <div class="column-margin">
          <vs-card class="jama">
            <div @click="navigate('jama')" class="pageLink">
              <h4>JAMA <span>network</span></h4>
              <a
                class="mb-4"
                href="https://jamanetwork.com/collections/46099/coronavirus-covid19"
                target="_blank"
                >Select a card to read more</a
              >
            </div>
            <RssCard
              v-for="(article, index) in limitedJamaArticles"
              :key="index"
              :article="article"
              :is-podcast="true"
            ></RssCard>
          </vs-card>
        </div>
      </div>
      <div class="p-3">
        <div class="column-margin">
          <vs-card class="ersj">
            <div @click="navigate('ersj')" class="pageLink">
              <h4>European Respiratory Society Journal</h4>
              <a
                class="mb-4"
                href="https://www.ersnet.org/the-society/news/novel-coronavirus-outbreak--update-and-information-for-healthcare-professionals"
                target="_blank"
                >Select a card to read more</a
              >
            </div>
            <RssCard
              v-for="(article, index) in limitedErsjArticles"
              :key="index"
              :article="article"
            ></RssCard>
          </vs-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import GlobalStatisticsCard from "@/modules/dashboard/components/GlobalStatisticsCard";
import AustralianStatisticsCard from "@/modules/dashboard/components/AustralianStatisticsCard";
import VictorianStatisticsCard from "@/modules/dashboard/components/VictorianStatisticsCard";
import Breadcrumbs from "@/components/general-components/breadcrumbs/Breadcrumbs";
import RssCard from "@/modules/dashboard/components/RssCard";

export default {
  name: "DashboardMainPage",
  components: {
    GlobalStatisticsCard,
    AustralianStatisticsCard,
    VictorianStatisticsCard,
    Breadcrumbs,
    RssCard
  },
  computed: {
    ...mapState([
      "AppActiveUser",
      "globalData",
      "australianData",
      "victorianData"
    ]),
    limitedLancetArticles() {
      return this.$store.getters.rssJournalResults("lancet").slice(0, 5);
    },
    limitedNejmArticles() {
      return this.$store.getters.rssJournalResults("nejm").slice(0, 5);
    },
    limitedJamaArticles() {
      return this.$store.getters.rssJournalResults("jama").slice(0, 5);
    },
    limitedErsjArticles() {
      return this.$store.getters.rssJournalResults("ersj").slice(0, 5);
    }
  },
  methods: {
    navigate(journal) {
      this.$router.push(`/dashboards/rssjournals/${journal}`);
    }
  }
};
</script>
